'use client';

import React from 'react';
import { styled } from '@mui/material';
import NextImage, { ImageProps as NextImageProps } from 'next/image';

export const Image = styled(NextImage, { name: 'JucyImage' })<NextImageProps>(() => ({}));
export type ImageProps = React.ComponentProps<typeof Image>;
